// LoadingScreen.js

import React from "react";


export const LoadingScreen = ({show=false}) => {
	return (
		show && <div className="flex items-center justify-center absolute bg-[rgba(0,0,0,0.5)] top-0 left-0 w-full h-full z-20 overflow-x-hidden">
			<div className="inline-block relative w-20 h-20">
				<div className="absolute border-4 border-white opacity-100 rounded-full animate-ripple"></div>
				<div className="absolute border-4 border-white opacity-100 rounded-full animate-ripple -delay-500"></div>
			</div>
            <style>{styles}</style>
		</div>
	);
};

const styles = `
  @keyframes ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    4.9% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    5% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }

  @keyframes ripple-delayed {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    4.9% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    5% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }

  .animate-ripple {
    animation: ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }

  .animate-ripple.-delay-500 {
    animation-delay: -0.5s;
    animation-name: ripple-delayed;
  }
`;


export default LoadingScreen;
